import { render, staticRenderFns } from "./pending-approval.vue?vue&type=template&id=51945eb2&"
import script from "./pending-approval.component.ts?vue&type=script&lang=ts&"
export * from "./pending-approval.component.ts?vue&type=script&lang=ts&"
import style0 from "./pending-approval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51945eb2')) {
      api.createRecord('51945eb2', component.options)
    } else {
      api.reload('51945eb2', component.options)
    }
    module.hot.accept("./pending-approval.vue?vue&type=template&id=51945eb2&", function () {
      api.rerender('51945eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/dashboard/components/Custom/pending-approval/pending-approval.vue"
export default component.exports